export interface ReactiveFormHostDashboardTitleTarget {
    setHeaderTitle(title: string): void;
}

export interface ReactiveFormHostDashboardTitleBridgeOptions {
    readonly target: ReactiveFormHostDashboardTitleTarget | null | undefined;
    readonly title: string;
}

/** Applies a resolved host title to any app-owned dashboard-like target. */
export class ReactiveFormHostDashboardTitleBridge {
    public static apply(options: ReactiveFormHostDashboardTitleBridgeOptions): string {
        options.target?.setHeaderTitle(options.title);
        return options.title;
    }
}
